'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { EmailLink } from '@/components/EmailIcon';
import { GitHubIcon, InstagramIcon, LinkedInIcon, XIcon } from '@/components/SocialIcons';
import { useAnalytics } from '@/hooks/useAnalytics';
import { SOCIAL_URLS } from '@/lib/contact';
function TrackedSocialLink(t0) {
  const $ = _c(13);
  let Icon;
  let platform;
  let props;
  if ($[0] !== t0) {
    ({
      icon: Icon,
      platform,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = platform;
    $[3] = props;
  } else {
    Icon = $[1];
    platform = $[2];
    props = $[3];
  }
  const {
    track
  } = useAnalytics();
  let t1;
  if ($[4] !== platform || $[5] !== track) {
    t1 = () => {
      track("social_link_click", {
        platform,
        location: "home"
      });
    };
    $[4] = platform;
    $[5] = track;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const trackSocialOpen = t1;
  let t2;
  if ($[7] !== Icon) {
    t2 = <Icon aria-hidden="true" className="ease-out-strong size-6 fill-zinc-500 transition duration-200 group-hover:-translate-y-0.5 group-hover:fill-zinc-600 group-active:scale-90 dark:fill-zinc-400 dark:group-hover:fill-zinc-300" />;
    $[7] = Icon;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props || $[10] !== t2 || $[11] !== trackSocialOpen) {
    t3 = <Link className="group -m-2.5 p-2.5" onClick={trackSocialOpen} {...props}>{t2}</Link>;
    $[9] = props;
    $[10] = t2;
    $[11] = trackSocialOpen;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
export function SocialLinksHome() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-6 flex gap-6"><TrackedSocialLink href={SOCIAL_URLS.twitter} aria-label="Follow on X" icon={XIcon} platform="twitter" target="_blank" rel="noopener noreferrer" /><TrackedSocialLink href={SOCIAL_URLS.instagram} aria-label="Follow on Instagram" icon={InstagramIcon} platform="instagram" target="_blank" rel="noopener noreferrer" /><TrackedSocialLink href={SOCIAL_URLS.github} aria-label="Follow on GitHub" icon={GitHubIcon} platform="github" target="_blank" rel="noopener noreferrer" /><TrackedSocialLink href={SOCIAL_URLS.linkedin} aria-label="Follow on LinkedIn" icon={LinkedInIcon} platform="linkedin" target="_blank" rel="noopener noreferrer" /><EmailLink /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}